export const PENDING = 'pending';
export const COMPLETE = 'complete';
export const FAILED = 'failed';
export const INITIAL = 'initial';
export const TIMEOUT = 'timeout';
export const POLLING = 'polling';
export const CONFLICT = 'conflict';

export type PromiseState = 'pending' | 'complete' | 'failed' | 'initial' | 'timeout' | 'polling' | 'conflict';

export interface PromiseResult<T, J> {
  promise?: Promise<void>;
  state: PromiseState;
  key: number;
  result?: J;
  numRetries?: number;
  errorMsg?: string;
  promiseParams: T;
}
export interface MultiPromiseMap<T, J> {
  [key: number]: PromiseResult<T, J>;
}

export interface PollingConfig<T,J> {
  pollIntervalInMs: number,
  allowedRunTimeInMs: number,
  pollMethod: (params: T) => Promise<J | undefined>,
}

export interface LongGatewayRequestParams<T,J> {
  promiseHandler: (params: T) => Promise<J>,
  promisesParams: Array<T>,
  pollingConfig?: PollingConfig<T,J>,
  concurrentRequests?: number,
  getRequestId?: (params: T, index: number) => number,
}